import axios from "axios";
export const getApiContent = async (url: string) => {
   const response = await axios.get(url);
   return response.data;
}
export const sendAnalitycs = async (url: string) => {
   const response = await axios.get('https://api.mockfly.dev/mocks/339d96f2-6c3d-43f4-a01e-8f48385441e7/evasto');
   return response.data;
}